import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPYellowCardsProps = StyledIconVariants & {
  css?: CSS;
  style?: React.CSSProperties;
};

export const SMPYellowCardsIcon = (props: SMPYellowCardsProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <rect id='Rectangle_689' data-name='Rectangle 689' width='12' height='16' rx='3' fill='#fbbd08' />
    </SMPIcon>
  );
};
